import $ from 'jquery';
import _ from 'lodash-es';
import getSizedImageURL from '../../../core/INF-getSizedImageURL';

export default (images) => {
  let html = '';

  _.each(images, (image) => {
    html += `
  <div 
    class="ProductImages__slide" 
    data-product-images-slide`;

    _.each(image.variants, (variant) => {
      html += `
      data-variant-${variant.id}='{"option1":"${variant.option1}","option2":"${variant.option2}","option3":"${variant.option3}"}'`;
    });

    const src = getSizedImageURL(image.src, '240x');
    const $img = $(`[data-product-images-seo] img[src="${src}"]`).eq(0).clone();
    // Trigger resize added to force carousel to resize on slow connections when new images load in
    $img.attr('onLoad', 'elementLoaded(this); triggerResize();');
    $img.attr('data-flickity-lazyload', getSizedImageURL(image.src, window.theme.pdp.image_size));

    html += `
  >
    ${$img[0].outerHTML}
  </div>`;
  });

  return html;
};